import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Docs: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.open('https://docs.canard.cloud', '_blank', 'noopener,noreferrer');
    navigate(-1);
  }, [navigate]);
  return null;
};

export default Docs;
